const ID_TOKEN_KEY = "id_token";

export const getToken = () => {
    return sessionStorage.getItem(ID_TOKEN_KEY);
};

export const saveToken = token => {
    sessionStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
    sessionStorage.removeItem(ID_TOKEN_KEY);
};

export default { getToken, saveToken, destroyToken };